import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { Sheet } from "@swivu/shared-ui";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import SidebarContent from "./SidebarContent.js";

const HamburgerMenuWrapper = () => {
  return (
    <Sheet.Root>
      <HamburgerMenu />
    </Sheet.Root>
  );
};
const HamburgerMenu = () => {
  const { changeMenuState, isOpen } = Sheet.useSheet();
  const location = useLocation();
  const prevLocationRef = useRef(location);

  useEffect(() => {
    if (prevLocationRef.current !== location && isOpen === true) {
      changeMenuState("close");
    }
    prevLocationRef.current = location;
  }, [location, changeMenuState, isOpen]);

  return (
    <>
      <Sheet.Trigger className={"md:hidden"}>
        <Bars3Icon
          className={`text-mono-500 dark:text-mono-200 size-9 -ml-1`}
        />
      </Sheet.Trigger>
      <Sheet.Content
        side={"left"}
        className={`bg-mono-100/90 dark:bg-mono-950/90  max-w-80 max-h-[100dvh] overflow-hidden pb-0`}
      >
        <div className={`flex h-full min-h-0 flex-col `}>
          <div
            className={`border-mono-200 dark:border-mono-700/50 mb-6 flex flex-none items-center justify-between border-b py-4`}
          >
            <div className={`flex items-center gap-4`}>
              <img
                className="h-8 w-auto"
                src="/assets/swivu-logo.svg"
                alt="Swivu Logo"
              />
              <h3 className={`text-xl`}>Swivu</h3>
            </div>
            <Sheet.Close>
              <XMarkIcon className={`size-7`} />
            </Sheet.Close>
          </div>
          <div className={`flex h-full min-h-0 flex-1 flex-col`}>
            <SidebarContent />
          </div>
        </div>
      </Sheet.Content>
    </>
  );
};

export default HamburgerMenuWrapper;
